import * as React from 'react';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Stack,
} from '@mui/material';
import { userService, reviewService } from '../api';
import {
  FormContainer,
  SelectElement,
  TextFieldElement,
  useForm,
} from 'react-hook-form-mui';
import { useNavigate } from 'react-router-dom';

interface FormInputs {
  comment: string;
  smeId: number;
}
interface Props {
  quid: string;
  reviewUid: string | null;
  canContactSME: boolean;
  onSubmitSuccess?: () => void;
}

export const ContactSme: React.FC<Props> = ({
  quid,
  reviewUid,
  canContactSME,
  onSubmitSuccess,
}) => {
  const navigate = useNavigate();
  const showReview = !!reviewUid;

  const formContext = useForm<FormInputs>({
    defaultValues: {
      comment: '',
    },
  });

  const { handleSubmit } = formContext;

  const { smeUsersList } = userService();

  const { sendReview } = reviewService();

  const smeSelectOptions = smeUsersList?.map(
    ({ first_name, last_name, id }) => ({
      id,
      label: `${first_name} ${last_name}`,
    }),
  );

  const handleSubmitReview = ({ comment, smeId }: FormInputs) => {
    sendReview({
      qa_uid: quid,
      requester_note: comment,
      reviewer_id: smeId,
    }).then(() => {
      if (onSubmitSuccess) {
        onSubmitSuccess();
      }
    });
  };

  const handleViewReview = () => {
    navigate(`/review/${reviewUid}`);
  };

  return (
    <FormContainer
      formContext={formContext}
      handleSubmit={handleSubmit(handleSubmitReview)}
    >
      {showReview && (
        <Box justifyContent="center" display="flex">
          <Button onClick={handleViewReview} variant="contained" size="small">
            View Review
          </Button>
        </Box>
      )}

      {canContactSME && !showReview && (
        <Box justifyContent="center" display="flex" width="100%">
          <Card elevation={0} sx={{ width: '100%' }}>
            <CardContent>
              <Stack spacing={2}>
                <SelectElement
                  name="smeId"
                  label="SMEs by domain"
                  fullWidth
                  options={smeSelectOptions}
                  required
                />

                <TextFieldElement
                  name="comment"
                  label="Comment"
                  fullWidth
                  required
                  rows={4}
                  about=""
                  multiline
                ></TextFieldElement>
              </Stack>
            </CardContent>
            <CardActions sx={{ justifyContent: 'end' }}>
              <Button variant="contained" size="small" type="submit">
                Submit
              </Button>
            </CardActions>
          </Card>
        </Box>
      )}
    </FormContainer>
  );
};
